<template>
  <div class="artile-footer van-hairline--top">
    <van-field @click="$emit('onShowInput')" readonly :border="false" left-icon="edit" :placeholder="article.comm_total?'写评论...':'抢沙发...'" />
    <tt-icon @click="$emit('onScrollComment')" name="comment" :badge="+article.comm_count||null"><span>评论</span></tt-icon>
    <tt-icon @click="handlerLike" :name="article.attitude===1?'like-sel':'like2'"><span>点赞</span></tt-icon>
    <tt-icon @click="handlerCollect" :name="article.is_collected?'collect-sel':'collect'"><span>收藏</span></tt-icon>
    <tt-icon @click="$emit('onShowShare')" name="share"><span>分享</span></tt-icon>
  </div>
</template>
<script>
import { likings, unLikings, collect, unCollect } from '@/api/article'
export default {
  name: 'ArticleFooter',
  props: {
    article: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async handlerLike () {
      if (this.article.attitude === 1) {
        await unLikings(this.article.art_id)
        this.article.attitude = -1
        this.article.like_count--
        this.$toast.success('取消点赞')
      } else {
        await likings(this.article.art_id)
        this.article.attitude = 1
        this.article.like_count++
        this.$toast.success('点赞成功')
      }
    },
    async handlerCollect () {
      if (this.article.is_collected) {
        await unCollect(this.article.art_id)
        this.article.is_collected = false
        this.$toast.success('取消收藏')
      } else {
        await collect(this.article.art_id)
        this.article.is_collected = true
        this.$toast.success('收藏成功')
      }
    }
  }
}
</script>
<style scoped lang="less">
.artile-footer {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  background: #fff;
  padding-left: 10px;
  > .van-field {
    flex: 1;
    background: #F7F8FA;
    height: 32px;
    border-radius: 16px;
    padding: 0 10px;
    line-height: 32px;
    ::v-deep .van-field__left-icon .van-icon {
      color: #ccc;
    }
  }
  .tt-icon {
    text-align: center;
    font-size: 20px;
    margin: 0 12px;
    > span {
      font-size: 10px;
      display: block;
    }
  }
}
</style>
